
import { onMounted, onUnmounted, ref, shallowRef } from '@vue/composition-api';
import isTouchDevice from 'is-touch-device';
import makeCancellablePromise from 'make-cancellable-promise';
import type ThumbnailArray from '~/type/ThumbnailArray';
import DotSlider from '~/components/DotSlider/DotSlider.vue';
import { useResizeStore } from '~/store/resize';
interface Coord {
  id: number;
  start: number;
  finish: number;
}
const __sfc_main = {};
__sfc_main.props = {
  image: {
    key: "image",
    required: false,
    type: Array,
    default: () => []
  },
  name: {
    key: "name",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const activeIndex = ref(0);
  const xCoord = ref(0);
  const photoWrappertWidth = ref(0);
  const arrCoord = ref<Coord[]>();
  const startX = ref(0);
  const targetCoords = shallowRef<DOMRect>();
  const resizeStore = useResizeStore();
  const promise = ref<ReturnType<typeof makeCancellablePromise> | null>(null);
  let newIndex: null | number;
  let unsubscribe: () => void;
  const root = shallowRef<HTMLDivElement>();
  const photo = shallowRef<HTMLImageElement[]>();
  onMounted(() => {
    resizeHandler();
    unsubscribe = resizeStore.$onAction(mutation => {
      if (mutation.name === 'setIsMobile') resizeHandler();
    });
  });
  onUnmounted(() => {
    if (unsubscribe) unsubscribe();
  });
  function resizeHandler() {
    if (!root.value) throw new Error('Root элемент не найден');
    if (props.image.length > 1) {
      if (isTouchDevice()) {
        root.value.addEventListener('touchstart', onTouchStart);
        root.value.addEventListener('touchend', onTouchEnd);
      } else {
        root.value.addEventListener('mousemove', onMouseMove);
        root.value.addEventListener('mouseleave', onMouseLeave);
        arrCoord.value = undefined;
        photoWrappertWidth.value = 0;
        targetCoords.value = undefined;
      }
    }
  }
  function onTouchStart(e: TouchEvent) {
    startX.value = e.changedTouches[0].screenX;
  }
  function onTouchEnd(e: TouchEvent) {
    const diffX = e.changedTouches[0].clientX - startX.value;
    if (Math.abs(diffX) > 15) {
      if (diffX >= 0) prev();else next();
    }
  }
  function next() {
    if (activeIndex.value === props.image.length - 1) change(0);else change(activeIndex.value + 1);
  }
  function prev() {
    if (activeIndex.value === 0) change(props.image.length - 1);else change(activeIndex.value - 1);
  }
  function onMouseMove(e: MouseEvent) {
    if (!root.value) throw new Error('Root элемент не найден');
    targetCoords.value = targetCoords.value || root.value.getBoundingClientRect();
    photoWrappertWidth.value = photoWrappertWidth.value || root.value.offsetWidth;
    arrCoord.value = arrCoord.value || createArrCoord();
    xCoord.value = e.clientX - targetCoords.value.left;
    arrCoord.value.forEach(el => {
      if (xCoord.value > el.start && xCoord.value < el.finish) change(el.id);
    });
  }
  function change(i: number) {
    if (i === 0) activeIndex.value = i;else asyncChange(i);
  }

  /**
   Логика работы переключения может показаться сложной, но тут главное понять суть:
   Пользователь переключается между фотками и он может переключаться так, что не будет
   дожидаться загрузки каждой фотки, а может как бы проскакивать некоторые. В этом случае
   нам надо отменять запрос на проставления предыдущего слайда, если фотка еще не загрузилась,
   но при этом нам уже нужно проставить новый слайд
  
   В итоге при такой стратегии через отмену промисов всё работает последовательно и как нужно:
   без лишних вызовов, без лишних подгрузок картинок и прочего
  */
  function asyncChange(i: number) {
    if (activeIndex.value !== i && newIndex !== i) {
      if (promise.value) {
        promise.value.cancel();
        promise.value = null;
      }
      const img = photo.value?.[i];
      if (img?.src) {
        activeIndex.value = i;
      } else if (img) {
        img.src = img.dataset.src || '';
        img.srcset = `${img.dataset.srcset} 2x`;
        newIndex = i;
        promise.value = makeCancellablePromise(new Promise<void>(resolve => {
          img.addEventListener('load', () => {
            resolve();
          }, {
            once: true
          });
        }));
        promise.value.promise.then(() => {
          activeIndex.value = newIndex!;
          newIndex = null;
          promise.value = null;
        });
      }
    }
  }
  function createArrCoord() {
    const dif = photoWrappertWidth.value / props.image.length;
    return props.image.map((el, id) => {
      const start = id * dif;
      const finish = (id + 1) * dif;
      return {
        id,
        start,
        finish
      };
    });
  }
  function onMouseLeave() {
    change(0);
  }
  return {
    activeIndex,
    root,
    photo
  };
};
__sfc_main.components = Object.assign({
  DotSlider
}, __sfc_main.components);
export default __sfc_main;
